import { queryKeys } from '@/lib/query-keys';
import { siteClient } from '@/lib/api/ts-rest';
import type { Site } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';

export const useSites = (organizationId: string | undefined) => {
  return useQuery<Site[], Error>({
    queryKey: queryKeys.organizations.sites(organizationId),
    queryFn: async () => {
      const res = await siteClient.listSites({
        params: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load sites');
      return res.body;
    },
    enabled: !!organizationId,
  });
};
